export function hasTrimmedValue(value: string) {
  return value.trim().length > 0
}

export function toOptionalNumber(value: string) {
  return value === '' ? undefined : Number(value)
}

export function isOptionalNonNegativeInteger(value: number | undefined) {
  return value === undefined || (Number.isInteger(value) && value >= 0)
}

export function isOptionalHttpUrl(value: string) {
  const trimmed = value.trim()

  if (!trimmed) {
    return true
  }

  try {
    const url = new URL(trimmed)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}
